/**
 * useGameData
 */

import { useParams } from 'react-router-dom';

import useGames from './store/useGames';

const useGameData = () => {

    const { gamePk } = useParams();

    const {
        loading,
        error,
        data,
    } = useGames([gamePk]);

    return {
        loading,
        data: data?.games[0],
        error,
    };

};

export default useGameData;
